module.exports = __webpack_public_path__ + "img/ms-icon-310x310.de8d7819.png";